import axios from "axios";
import { call, put, take, takeLatest } from "redux-saga/effects";
import { axiosInstance } from "../../network/apis";
import { GET_CHART_NAME, GET_DASHBOARD_CONFIG, GET_DASHBOARD_DAILY_DATA, GET_DASHBOARD_MONTHLY_STATS, GET_DASHBOARD_MONTH_DATA, GET_DASHBOARD_WEEKLY_DATA, GET_LAST_UPDATE_DASHBOARD_URL, GET_LAST_UPDATE_LEADERBOARD_URL, GET_LEADERBOARD_HISTORY_DATA, GET_LEADERBOARD_TABLE_DAILY } from "../../network/apis/apiPath";
import { getLocalStore, setLocalStore } from "../../utils/Helper";
import { DASHBOARD_CONFIG, DASHBOARD_DAILY_CONTEST, DASHBOARD_MONTHLY_CONTEST, DASHBOARD_WEEKLY_CONTEST, GET_DASHBOARD_LASTUPDATED, GET_LEADERBOARD_LASTUPDATED, LEADERBOARD_HISTORY_DATA, LEADERBOARD_TABLE_DATA, MONTHLY_CHART_NAME, MONTHLY_PARTICULAR_CHART_DATA } from "../type";
import { saveContestId, saveDashboardConfig, saveDashboardDailyData, saveDashboardMonthlyStatsData, saveDashboardWeeklyData, saveGetDashboardLastupdate, saveGetLeaderboardLastupdate, saveLeaderBoardHistoryData, saveLeaderBoardTableData, saveMonthlyChartName, saveMonthlyParticularChartData } from "./dashboardConfigSlice";


function* dashboardConfigWorker(action) {
    const { payload } = action;
    const { EmployeeCode } = payload
    try {
        const response = (yield call(axios.get, `${GET_DASHBOARD_CONFIG}?employeeCode=${EmployeeCode}`))
        if (response.data) {
            const contestId = response.data?.contests[0]?.contestId
            setLocalStore('ContestId', contestId);
            yield put(saveDashboardConfig(response.data));
            // yield put(saveContestId(response.data?.contests[0]?.contestId));
        }
    } catch (error) {
        console.log(error);
    }
}

function* dashboardWeeklyDataWorker(action) {
    const { payload } = action;
    const { contestId, EmployeeCode } = payload

    try {
        const response = (yield call(axiosInstance.get, `${GET_DASHBOARD_WEEKLY_DATA}/${contestId}?employeeCode=${EmployeeCode}`))
        if (response.data) {
            yield put(saveDashboardWeeklyData(response.data))
        }

    } catch (error) {
        console.log(error)
    }
}

function* dashboardDailyDataWorker(action) {
    const { payload } = action;
    const { contestId, EmployeeCode } = payload

    try {
        const response = (yield call(axiosInstance.get, `${GET_DASHBOARD_DAILY_DATA}/${contestId}?employeeCode=${EmployeeCode}`))
        if (response.data) {
            yield put(saveDashboardDailyData(response.data))
        }

    } catch (error) {
        console.log(error)
    }
}

function* dashboardMonthlyDataWorker(action) {
    const { contestId, EmployeeCode, selectedMonth, selectedYear } = action.payload
    try {
        const response = (yield call(axiosInstance.get, `${GET_DASHBOARD_MONTHLY_STATS}/${contestId}?employeeCode=${EmployeeCode}&month=${selectedMonth}&year=${selectedYear}`))
        if (response.data) {
            yield put(saveDashboardMonthlyStatsData(response.data))
        }
    } catch (error) {
        console.log('monthError', error)
    }
}

function* leaderBoardTableData(action) {
    const { itemToShow, leaderBoardId, shownPage } = action.payload
    try {
        const response = (yield call(axiosInstance.get, `${GET_LEADERBOARD_TABLE_DAILY}/${leaderBoardId}?pageNumber=${shownPage}&pageSize=${itemToShow}`))
        if (response.data) {
            yield put(saveLeaderBoardTableData(response.data))
        }

    } catch (error) {
        console.log(error)
    }
}

function* leaderBoardHistoryData(action) {
    const { contestScoreboardId, EmployeeCode, selectedYear, selectedMonth } = action.payload
    try {
        const response = (yield call(axiosInstance.get, `${GET_LEADERBOARD_HISTORY_DATA}/${contestScoreboardId}?employeeCode=${EmployeeCode}&month=${selectedMonth}&year=${selectedYear}`))
        if (response.data) {
            yield put(saveLeaderBoardHistoryData(response.data))
        }

    } catch (error) {
        console.log(error);
    }
}

function* getMonthlyChartName(action) {
    const { contestId, EmployeeCode } = action.payload
    try {
        const response = (yield call(axiosInstance.get, `${GET_CHART_NAME}/${contestId}?employeeCode=${EmployeeCode}`))
        if (response.data) {
            yield put(saveMonthlyChartName(response.data))
        }

    } catch (error) {
        console.log(error);
    }
}

function* getMonthlyParticularChartData(action) {
    const { contestId, type, EmployeeCode, selectedMonth, selectedYear, } = action.payload
    try {
        const response = (yield call(axiosInstance.get, `${GET_CHART_NAME}/${contestId}/${type}?employeeCode=${EmployeeCode}&month=${selectedMonth}&year=${selectedYear}`))
        if (response.data) {
            yield put(saveMonthlyParticularChartData(response.data))
        }

    } catch (error) {
        console.log(error);
    }
}

function* getDashboardLastupdate(action) {
    const { contestId, EmployeeCode } = action.payload;
    try {
        const response = (yield call(axiosInstance.get, `${GET_LAST_UPDATE_DASHBOARD_URL}/${contestId}?employeeCode=${EmployeeCode}`));
        if (response.data) {
            yield put(saveGetDashboardLastupdate(response.data))
        }
    } catch (error) {
        console.log(error);
    }
}

function* getLeaderboardLastupdate(action) {
    const { contestScoreBoardId, EmployeeCode } = action.payload;
    try {
        const response = (yield call(axiosInstance.get, `${GET_LAST_UPDATE_LEADERBOARD_URL}/${contestScoreBoardId}?employeeCode=${EmployeeCode}`));
        if (response.data) {
            yield put(saveGetLeaderboardLastupdate(response.data))
        }
    } catch (error) {
        console.log(error);
    }

}

export function* dashboardConfigWatcher() {
    yield takeLatest(DASHBOARD_CONFIG, dashboardConfigWorker);
    yield takeLatest(DASHBOARD_WEEKLY_CONTEST, dashboardWeeklyDataWorker);
    yield takeLatest(DASHBOARD_DAILY_CONTEST, dashboardDailyDataWorker);
    yield takeLatest(DASHBOARD_MONTHLY_CONTEST, dashboardMonthlyDataWorker);
    yield takeLatest(LEADERBOARD_TABLE_DATA, leaderBoardTableData);
    yield takeLatest(LEADERBOARD_HISTORY_DATA, leaderBoardHistoryData);
    yield takeLatest(MONTHLY_CHART_NAME, getMonthlyChartName);
    yield takeLatest(MONTHLY_PARTICULAR_CHART_DATA, getMonthlyParticularChartData);
    yield takeLatest(GET_DASHBOARD_LASTUPDATED, getDashboardLastupdate);
    yield takeLatest(GET_LEADERBOARD_LASTUPDATED, getLeaderboardLastupdate);
}
